import React from 'react';
import { Card, Row, Col, Container, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import GenericGrid from '../../../Shared/Grid/GenericGrid';
function PendingApplications({ data, schema }) {
    const pendingAppSchema =  [
        ['License Type', 'licenseType'],
        ['Status', 'pendingApplicationStatus']
    ]
    return (
        <div className="profilePendingApps">
            <Card>
                <Card.Header>
                    <Card.Title className="d-flex align-items-center" style={{ marginBottom: '0' }}>
                        <b>Pending Applications</b>
                        <span className="ms-auto">
                            <Button as={Link} to="/firm/applications" variant="success" className="fw-bold">Check Status</Button>
                        </span>
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <Container>
                        <GenericGrid data={data} columns={pendingAppSchema}/>
                    </Container>
                </Card.Body>
            </Card>
        </div>
    )
}

export default PendingApplications;